import { useMemo, useEffect, useState } from "react";
import useStore from "../../hooks/useStore";
import { STATIC_GROUPS } from "../../constants/constants";
import BarChart from "../charts/barChart";
import { observer } from "mobx-react";
import ColumnChart from "../charts/columnChart";

function WasteDashboardAccordion({ year, selectedUnit = "MT" }) {
  const {
    dashboardStore: { dashboardDetails },
    userStore,
    companyStore
  } = useStore();

  // Log backend response for group F
  // useEffect(() => {
  //   if (companyStore.groupValues) {
  //     console.log("Fetched group F values (waste):", companyStore.groupValues);
  //   }
  // }, [companyStore.groupValues]);
  // Fetch group F values for waste
  // Local state for backend group values
  const [groupValues, setGroupValues] = useState({});

  useEffect(() => {
    if (year) {
      const companyId = Number((userStore.userData && userStore.userData.companyId) || localStorage.getItem("companyId"));
      const companyUnit = companyStore.companyUnit;
      const payload = {
        year,
        groupNames: ["F"],
        reportType: "waste",
        companyId,
        companyUnit,
      };
      async function fetchGroupValues() {
        try {
          const response = await fetch(`${process.env.REACT_APP_BASE_URL}company/getGroupValues`, {
             method: "POST",
  headers: {
    "Content-Type": "application/json"
  },
  body: JSON.stringify(payload),
          });
          console.log("Waste group values response:", response);
          const data = await response.json();
          console.log("Fetched waste group values:", data);
          setGroupValues(data.data.waste || {});
        } catch (err) {
          console.error("[Error] Fetching group values:", err);
        }
      }
      fetchGroupValues();
    }
  }, [year, companyStore, userStore]);
  // Conversion logic
  const convertValue = (value, fromUnit, toUnit) => {
    if (fromUnit === toUnit) return value;
    if (fromUnit === "MT" && toUnit === "Kg") return value * 1000;
    if (fromUnit === "MT" && toUnit === "M3") return value * 1;
    if (fromUnit === "MT" && toUnit === "L") return value * 1000;
    return value;
  };

  const barChartsGroupData = useMemo(() => {
    const tempData = dashboardDetails?.charts?.waste;
    const fromUnit = "MT";
    const toUnit = selectedUnit;
    const result = ["B", "C", "F"].map((group) => {
      const data = [year - 1, year].map((yr) => {
        const temp = tempData?.[yr]?.reduce(
          (acc, curr) => ({ ...acc, ...curr }),
          {}
        );
        let value;
        if (group === "B") {
          value = ["B1", "B2", "B3"].reduce((acc, curr) => acc + (temp?.[curr]?.prevValue || 0), 0);
        } else if (group === "C") {
          value = ["C1", "C2"].reduce((acc, curr) => acc + (temp?.[curr]?.prevValue || 0), 0);
        } else {
          value = temp?.[group]?.prevValue || 0;
        }
        return convertValue(value, fromUnit, toUnit);
      });
      return {
        label: STATIC_GROUPS.waste[group],
        data,
        unit: toUnit,
      };
    });
    return result;
  }, [dashboardDetails?.charts?.waste, year, selectedUnit]);

  // const data = revenuePageData?.fieldData?.filter(
  //   (e) => e?.type === "waste" && e?.title?.includes("Revenue")
  // );

  // const chartData = data
  //   ?.filter((e) => year?.toString() === e?.year?.toString())
  //   ?.map((ele) => ({
  //     name: ele?.title,
  //     data: [year - 1, year].map(
  //       (f) =>
  //         data?.find(
  //           (d) =>
  //             f?.toString() === d?.year?.toString() && ele?.title === d?.title
  //         )?.value || 0
  //     ),
  //   }));

  return (
    <div className="row h-100  ">
      {barChartsGroupData &&
        barChartsGroupData?.map?.(({ label, data, unit }, index) => {
          // For any group present in backend response, use backend data
          const groupKey = Object.keys(STATIC_GROUPS.waste).find(key => STATIC_GROUPS.waste[key] === label);
          const backendGroup = groupValues?.[groupKey];
       //   console.log("backendGroup for", groupKey, backendGroup);
            if (backendGroup) {
              const prevYear = year - 1;
              const chartData = [
                backendGroup[prevYear]?.prevValue ?? 0,
                backendGroup[year]?.prevValue ?? 0
              ];
              const chartUnit = backendGroup[year]?.unit || backendGroup[prevYear]?.unit || unit;
              const hasData = chartData.some(val => val !== 0 && val !== null && val !== undefined);
              return (
                <div key={index} className="col-xl-6  mb-3">
                  <div className="card h-100  ">
                    <div className="card-body">
                      <div className="d-flex  justify-content-between ">
                        <h4 className="card-title mb-4 donut-heading">
                          {label}
                        </h4>
                        <div className="ms-auto">
                          <div className="toolbar d-flex flex-wrap gap-2 ">
                            <div className="">
                              <p className="text-muted mb-1">Unit</p>
                              <h6>{chartUnit}</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                      {hasData ? (
                        <BarChart
                          series={[{ data: chartData, name: label }]}
                          categories={[
                            `CY${(year - 1).toString().slice(2)}`,
                            `CY${year.toString().slice(2)}`,
                          ]}
                          unit={chartUnit}
                        />
                      ) : (
                        <div className="text-center text-muted">No data available</div>
                      )}
                    </div>
                  </div>
                </div>
              );
            }
          // For other groups, use chart data
          const hasData = data.some(val => val !== 0 && val !== null && val !== undefined);
          return (
            <div key={index} className="col-xl-6  mb-3">
              <div className="card h-100  ">
                <div className="card-body">
                  <div className="d-flex  justify-content-between ">
                    <h4 className="card-title mb-4 donut-heading">
                      {label}
                    </h4>
                    <div className="ms-auto">
                      <div className="toolbar d-flex flex-wrap gap-2 ">
                        <div className="">
                          <p className="text-muted mb-1">Unit</p>
                          <h6>{unit}</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  {hasData ? (
                    <BarChart
                      series={[{ data, name: label }] || []}
                      categories={[
                        `CY${(year - 1).toString().slice(2)}`,
                        `CY${year.toString().slice(2)}`,
                      ]}
                      unit={unit}
                    />
                  ) : (
                    <div className="text-center text-muted">No data available</div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      {/* <div className="card">
        <div className="card-body">
          <ColumnChart
            data={chartData}
            yaxis={[]}
            categories={[
              `FY${(year - 1).toString().slice(2)}`,
              `FY${year.toString().slice(2)}`,
            ]}
          />
        </div>
      </div> */}
    </div>
  );
}

export default observer(WasteDashboardAccordion);



